import Login from '@pages/Login.vue';
import MagiclinkLogin from '@pages/MagiclinkLogin.vue';
import RequestSignUp from '@pages/RequestSignUp.vue';
import ForgotPassword from '@pages/ForgotPassword.vue';
import ResetPassword from '@pages/ResetPassword.vue';

const permissions = [
  {
    role: 'Member',
    access: false,
    redirect: 'Dashboard',
  },
  {
    role: 'Company',
    access: false,
    redirect: 'Dashboard',
  },
  {
    role: 'Superuser',
    access: false,
    redirect: 'Dashboard',
  },
];

export default [
  {
    path: '/',
    name: 'Home',
    component: MagiclinkLogin,
    meta: {
      permissions: permissions,
      flexContainer: true,
      noBodyBackground: true,
      hideNav: true,
    },
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      permissions: permissions,
      flexContainer: true,
      noBodyBackground: true,
      hideNav: true,
    },
  },
  {
    path: '/request-signup',
    name: 'RequestSignUp',
    component: RequestSignUp,
    meta: {
      permissions: permissions,
      flexContainer: true,
      noBodyBackground: true,
      hideNav: true,
    },
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword,
    meta: {
      permissions: permissions,
      flexContainer: true,
      hideNav: true,
      noBodyBackground: true,
    },
  },
  {
    path: '/password-reset/confirm/:uid/:token',
    name: 'ResetPassword',
    component: ResetPassword,
    meta: {
      permissions: permissions,
      flexContainer: true,
      hideNav: true,
      noBodyBackground: true,
    },
  },
  {
    path: '/password/reset/key/:uid-:token',
    name: 'ResetPasswordFromKey',
    component: ResetPassword,
    meta: {
      permissions: permissions,
      flexContainer: true,
      hideNav: true,
      noBodyBackground: true,
    },
  },
];
